import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import OpsRisk from './pages/OpsRisk';
import AIRisk from './pages/AIRisk';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
	<Route path="/opsrisk" element={<OpsRisk />} />
        <Route path="/airisk" element={<AIRisk />} />
      </Routes>
    </Router>
  );
}

export default App;
